import { Component } from '@angular/core';
import {
  ReservationStatus,
  ReservationStatusesDisplayNames
} from '@app/features/operations/reservations/reservations.model';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ChipModule } from 'primeng/chip';

@Component({
  selector: 'app-reservation-status-renderer',
  standalone: true,
  imports: [ChipModule],
  templateUrl: './reservation-status-renderer.component.html',
  host: { class: 'd-block text-center' }
})
export class ReservationStatusRendererComponent implements ICellRendererAngularComp {
  value: ReservationStatus = 0;
  displayName = '';

  agInit(params: ICellRendererParams): void {
    this.value = params.value;
    this.displayName = ReservationStatusesDisplayNames[params.value];
  }

  refresh(params: ICellRendererParams): boolean {
    this.value = params.value;
    this.displayName = ReservationStatusesDisplayNames[params.value];
    return true;
  }
}
